/**
 * "I want 20 slots" (user, 20/10/2026 — "without having to remove one by
 * one or add"): what setting the day's number of slots does to the list —
 * how many to add, or which to remove: the last ones of the list as it
 * reads, a pinned slot only once no other is left. Pure.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DraftSlot } from '../../../../../drop-generator.types';

/** The most slots a container saves (the save's own cap). */
export const SLOT_MAX = 500;

export type CountPlan = { add: number } | { remove: number[] } | null;

/** `order` = the slots' indexes in the order the list reads (drop-list-order). */
export function countPlan(slots: DraftSlot[], target: number, order: number[]): CountPlan {
  const want = Math.max(0, Math.min(SLOT_MAX, Math.floor(target)));
  if (want > slots.length) return { add: want - slots.length };
  if (want === slots.length) return null;
  const back = [...order].reverse();
  const loose = back.filter((i) => slots[i].pinnedAtMin === null);
  const pinned = back.filter((i) => slots[i].pinnedAtMin !== null);
  return { remove: [...loose, ...pinned].slice(0, slots.length - want) };
}

/** The button's words for a plan. */
export function countWords(plan: Exclude<CountPlan, null>): string {
  if ('add' in plan) return `Add ${plan.add} slot${plan.add === 1 ? '' : 's'}`;
  const n = plan.remove.length;
  return n === 1 ? 'Remove the last slot' : `Remove the last ${n}`;
}
